import { IMenuSettings } from './types';

const parseBusinessDocumentVisibility = (menuSettings: IMenuSettings, docType: number) =>
    !!menuSettings?.BusinessDocEnables?.find((item) => item.BusinessDocType === docType);

export default parseBusinessDocumentVisibility;
